import styled, { css } from 'styled-components';
import { AlertTriangle } from '@carvana/icons';
import { cvBreakpoint768 } from '@carvana/theme';

export const AlertIcon = styled(AlertTriangle)`
  & > svg {
    height: 50px;
    width: 50px;
  }

  & > svg > g {
    fill: ${props => props.theme.carvana.blue.medium};
  }
`;

export const buttonStyles = css`
  width: 250px;
  height: 56px;
`;

export const Copy = styled.p`
  text-align: center;
  line-height: 28px;
  font-size: 18px;
  padding: 40px 30px;

  @media (min-width: ${cvBreakpoint768}px) {
    padding: 40px 161px;
  }
`;

export const Wrapper = styled.div`
  align-items: center;
  background-color: ${props => props.theme.carvana.gray.background};
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 45px 0px;
`;
